export default __webpack_public_path__ + "static/media/triggersDefault.9e8b9a12.png";